import React, { useEffect } from "react"
import AnimiatedPage from "../../AnimiatedPage"
import Hero from '../../Components/Hero/Hero'

function Home(props) {

  useEffect(()=>{
    document.title = 'SHARVIL Business Group'
    },[])
  return (

   <div>
     <Hero onScroll={props.onScroll} />
   </div>

  )
}

export default Home